<div class="wrapper" *ngIf="successPopupText$ | async as popupText">
    <img src="assets/icons/success-popup-icon.svg" alt="">
    <p>{{ popupText | translate}}</p>
</div>
<div class="wrapperFail" *ngIf="failPopupText$ | async as popupText">
    <img src="assets/icons/fail-popup-icon.svg" alt="">
    <p>{{ popupText | translate}}</p>
</div>